import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCustomerCart } from "../contexts/CustomerCartContext";

const CustomerCartBanner = () => {
  const { t } = useTranslation();
  const { customer, setCustomer } = useCustomerCart();

  if (!customer) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 24,
        left: 16,
        zIndex: 1050,
        backgroundColor: "#f6a623",
        borderRadius: 8,
        boxShadow: "0 4px 16px rgba(0,0,0,0.22)",
        padding: "10px 14px",
        minWidth: 210,
        maxWidth: 290,
        color: "#1a1a1a",
      }}
    >
      <div style={{ fontSize: "0.75em", opacity: 0.7, marginBottom: 4, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.03em" }}>
        <i className="ri-user-follow-fill me-1" />
        {t("customerCart.bannerWorking")}
      </div>
      <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
        <span style={{ fontWeight: 700, fontSize: "0.88em", display: "flex", alignItems: "center", gap: 5, overflow: "hidden" }}>
          <span className="text-truncate">{customer.username}</span>
        </span>
        <button
          onClick={() => { setCustomer(null); window.location.href = "/"; }}
          style={{
            background: "rgba(0,0,0,0.12)",
            border: "none",
            borderRadius: 4,
            padding: "1px 7px",
            cursor: "pointer",
            color: "#1a1a1a",
            fontSize: "0.75em",
            fontWeight: 600,
            flexShrink: 0,
          }}
        >
          {t("customerCart.end")}
        </button>
      </div>
      <div style={{ fontSize: "0.78em", opacity: 0.75, marginBottom: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {customer.email}
      </div>
      <div className="d-flex flex-column gap-1">
        <Link
          to="/cart"
          style={{
            textAlign: "center",
            background: "rgba(0,0,0,0.15)",
            color: "#1a1a1a",
            borderRadius: 5,
            padding: "4px 8px",
            fontSize: "0.82em",
            fontWeight: 600,
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
          }}
        >
          <i className="ri-shopping-cart-2-line" />
          {t("customerCart.goToCart")}
        </Link>
        <Link
          to="/customer-cart"
          style={{
            textAlign: "center",
            background: "rgba(0,0,0,0.15)",
            color: "#1a1a1a",
            borderRadius: 5,
            padding: "4px 8px",
            fontSize: "0.82em",
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
          }}
        >
          <i className="ri-refresh-line" />
          {t("customerCart.changeCustomer")}
        </Link>
      </div>
    </div>
  );
};

export default CustomerCartBanner;
